
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'Test',
	'visualizationSlideoutTitle': 'Visualisierungen',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Zahl eingeben',
	'maxValuePlaceholder': 'Zahl eingeben',
	'customRangeErrorMessage': 'Der Wert muss eine Zahl sein.',
	'propFillColor': 'Füllfarbe',
	'propBorderColor': 'Umrandungsfarbe',
	'propColorPalette': 'Aktuelle Farbpalette',
	'propColorPaletteChangeLabel': 'Farbpalette ändern',
	'propNewColorPaletteLabel': 'Benutzerdefinierte Farbpalette erstellen',
	'propNewHeatPaletteLabel': 'Benutzerdefinierte Palette für Heat-Map erstellen',
	'propDonutRadius': 'Ringradius',
	'showTitleLabel': 'Titel anzeigen',
	'titleTypeLabel': 'Titeltyp',
	'smartTitleLabel': 'Intelligenter Titel',
	'customTitleLabel': 'Angepasster Titel',
	'noTitleLabel': 'Kein Titel',
	'propHeatScalePalette': 'Aktuelle Palette für Heat-Map',
	'propHeatPaletteChangeLabel': 'Palette für Heat-Map ändern',
	'propMaintainAxisScales': 'Achsenskala beibehalten',
	'propLineAndSymbolColor': 'Linien- und Symbolfarbe',
	'propLineAndSymbolPalette': 'Palette für Linien- und Symbolfarbe',
	'propElementColor': 'Elementfarbe',
	'propColumnColor': 'Säulenfarbe',
	'propColumnPalette': 'Farbpalette für Säulendiagramm',
	'propColumnHeatPalette': 'Palette für Heat-Map',
	'propBarColor': 'Balkenfarbe',
	'propGoalColor': 'Ziel - Farbe',
	'propToColor': 'Bis - Farbe',
	'propFromColor': 'Von - Farbe',
	'propNumberValidationErrorMessageId': 'Zahl eingeben',
	'fontSizeAuto': 'Automatisch',
	'propAutoBinCount': 'Anzahl der Gruppen',
	'propAutoBinToggle': 'Automatische Gruppierung',
	'tabName_general': 'Allgemein',
	'tabName_visDetails': 'Details',
	'tabName_animation': 'Animation',
	'tabName_mediaDetails': 'Mediendetails',
	'tabName_webDetails': 'Webseitendetails',
	'tabName_imageDetails': 'Bilddetails',
	'tabName_visualization': 'Visualisierung',
	'tabName_text': 'Text',
	'sectionName_colorsAndThemes': 'Farbe und Motive',
	'sectionName_appearance': 'Darstellung',
	'sectionName_general': 'Allgemein',
	'sectionName_colorPalette': 'Farbe',
	'sectionName_axis': 'Achse',
	'sectionName_axis_label': 'Achse',
	'sectionName_legend': 'Legende',
	'sectionName_chart': 'Diagramm',
	'sectionName_regionLayer': 'Regionsebene',
	'sectionName_pointLayer': 'Punktebene',
	'sectionName_latLongLayer': 'Ebene für Breitengrad/Längengrad',
	'sectionName_pathLayer': 'Pfadebene',
	'sectionName_xAxis': 'X-Achse',
	'sectionName_yAxis': 'Y-Achse',
	'sectionName_xAxis_title': 'X-Achsentitel',
	'sectionName_yAxis_title': 'Y-Achsentitel',
	'sectionName_xAxis_label': 'X-Achsenbeschriftung',
	'sectionName_yAxis_label': 'Y-Achsenbeschriftung',
	'sectionName_column_yAxis': 'Spalte - Y-Achse',
	'sectionName_column_yAxis_label': 'Spalte - Y-Achsenbeschriftung',
	'sectionName_column_yAxis_title': 'Spalte - Y-Achsentitel',
	'sectionName_line_yAxis': 'Zeile - Y-Achse',
	'sectionName_line_yAxis_label': 'Zeile - Y-Achsenbeschriftung',
	'sectionName_line_yAxis_title': 'Zeile - Y-Achsentitel',
	'sectionName_title': 'Titel',
	'sectionName_dataValueLabels': 'Datenwertbeschriftungen',
	'sectionName_style': 'Stil',
	'propTransparencyDescription': 'Objekt mehr oder weniger transparent gestalten. Einen Wert zwischen 0 und 100 eingeben.',
	'smart_annotation_unauthorized': 'Annotationen: unbefugter Zugriff',
	'smart_annotation_method': 'Annotationen: Methode nicht zulässig',
	'smart_annotation_media': 'Annotationen: Medientyp nicht zulässig',
	'smart_annotation_input': 'Annotationen: Eingabe ungültig',
	'smart_annotation_internal': 'Annotationen: interner Systemfehler',
	'smart_annotation_generic_error': 'Annotationen: Servicefehler',
	'smart_annotation_dialog_title': 'Insights',
	'smart_annotation_Show_Insights': 'Insights anzeigen',
	'smart_annotation_Relationship': 'Die Beziehung ist',
	'forecast_enter_number': 'Zahl eingeben zwischen ',
	'and': ' und ',
	'smart_errors': 'Annotationsfehler:',
	'smart_warnings': 'Annotationswarnungen:',
	'smart_annotation_insight_icon_title': 'Insights',
	'smart_annotations_toggle_on': 'Insights aktivieren',
	'smart_annotations_toggle_off': 'Insights inaktivieren',
	'smart_annotation_toggle_on': 'Aktivieren',
	'smart_annotation_toggle_off': 'Inaktivieren',
	'smart_annotation_insight_unavailable': 'Zurzeit sind keine Insights verfügbar',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Keine Insights verfügbar, wenn ein Filter für obere oder untere % angewendet wird.',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Keine Prognose verfügbar, wenn ein Filter für obere oder untere % angewendet wird.',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Es sind keine Insights verfügbar, wenn ein Filter für obere oder untere % angewendet wird und mehrere Spalten im Feld vorhanden sind.',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Es ist keine Prognose verfügbar, wenn ein Filter für obere oder untere % angewendet wird und mehrere Spalten im Datenfeld vorhanden sind.',
	'forecast_title': 'Prognose',
	'forecast_show': 'Prognose anzeigen',
	'forecast_toggle_on': 'Prognose aktivieren',
	'forecast_toggle_off': 'Prognose inaktivieren',
	'statDetailsPerspectiveTitle': 'Analyse',
	'emptyStatDetailsPanel': 'Für die aktuelle Visualisierung ist keine zusätzliche Analyse verfügbar.',
	'predict_errors': 'Analysefehler',
	'predict_warnings': 'Analysewarnungen',
	'fpd_invalid_data_source': 'Dieser Datenquelle ist kein Smarts-Modul zugeordnet.',
	'fpd_network_issue': 'Bei der Durchführung einer Analyse für diese Datenquelle ist ein Problem aufgetreten.',
	'fpd_data_source_category': 'Smarts-Modul fehlt',
	'fpd_response_errors': 'Empfohlene Einflussfaktoren - Fehler',
	'fpd_response_warnings': 'Empfohlene Einflussfaktoren - Warnungen',
	'catalyst_service_bad_request': 'Ungültige Anforderung',
	'catalyst_service_unkown_Id': 'Unbekannte Anforderungs-ID gefunden',
	'catalyst_service_internal_server_error': 'Interner Serverfehler',
	'catalyst_service_generic_error': 'Catalyst-Servicefehler',
	'catalyst_service_error': 'Dieser Service ist zurzeit nicht verfügbar.',
	'propLegendPosition': 'Position der Legende',
	'propLeft': 'Links',
	'propRight': 'Rechts',
	'propTop': 'Oben',
	'propBottom': 'Unten',
	'propNone': 'Ohne',
	'propLegendDisplay': 'Legende anzeigen',
	'targetThicknessPlaceHolder': '%{min} bis %{max}',
	'targetThicknessErrorMsg': 'Eine ganze Zahl zwischen %{min} und %{max} eingeben.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Einflussfaktoren (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'ausgewählt)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Auf Standardwerte zurücksetzen',
	'possibelKeyDriver_AddNewDrivers': 'Weitere Einflussfaktoren hinzufügen',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Suche für das Hinzufügen weiterer Einflussfaktoren',
	'possibleKeyDrivers_MaxPossibleReached': 'Einige Einflussfaktor abwählen, um weitere Einflussfaktor hinzuzufügen oder auszuwählen',
	'possibleKeyDrivers_Recommended': 'Empfohlen',
	'visRecommendedTypes': 'Empfohlene Visualisierungstypen',
	'visRecommender_smartsfailure': 'Zurzeit sind keine Visualisierungsempfehlungen verfügbar.',
	'visMore': 'Mehr...',
	'visMoreTooltip': 'Weitere Visualisierungen',
	'visOtherTypes': 'Andere Visualisierungstypen',
	'visChange': 'Visualisierung ändern',
	'automaticTypeCaption': 'Automatisch',
	'propVisType': 'Visualisierungstypen',
	'dlg_loading': 'Ladeoperation wird ausgeführt...',
	'snippetListChartCaption': 'Liste mit Snippets',
	'convoClusterChartCaption': 'Dialogcluster',
	'areaChartCaption': 'Flächendiagramm',
	'barChartCaption': 'Balkendiagramm',
	'columnChartCaption': 'Säulendiagramm',
	'stackedbarChartCaption': 'Gestapeltes Balkendiagramm',
	'stackedcolumnChartCaption': 'Gestapeltes Säulendiagramm',
	'bubbleChartCaption': 'Blasendiagramm',
	'marimekkoChartCaption': 'Marimekko-Diagramm',
	'cometChartCaption': 'Analyse der Einflussfaktoren',
	'scatterChartCaption': 'Streudiagramm',
	'lineChartCaption': 'Liniendiagramm',
	'pointChartCaption': 'Punktdiagramm',
	'heatChartCaption': 'Heat-Map',
	'bulletChartCaption': 'Bullet-Diagramm',
	'waterfallChartCaption': 'Wasserfalldiagramm',
	'radarChartCaption': 'Radardiagramm',
	'boxplotChartCaption': 'Boxplot',
	'pieChartCaption': 'Kreisdiagramm',
	'mapChartCaption': 'Landkarte',
	'radialBarChartCaption': 'Radialdiagramm',
	'compositeChartCaption': 'Linien- und Säulendiagramm',
	'wordCloudChartCaption': 'Wortwolke',
	'networkChartCaption': 'Netzdiagramm',
	'relationshipNetworkChartCaption': 'Beziehungsnetz',
	'treemapChartCaption': 'Treemap',
	'packedBubbleChartCaption': 'Kompaktes Blasendiagramm',
	'hierarcicalPackedBubbleChartCaption': 'Blasendiagramm mit Hierarchien',
	'spiralChartCaption': 'Spiraldiagramm',
	'decisionTreeChartCaption': 'Entscheidungsstruktur',
	'legacyMapChartCaption': 'Vorgängerlandkarte',
	'sunburstChartCaption': 'Sunburst-Diagramm',
	'visUsageComparison': 'Vergleich',
	'visUsageRelationships': 'Beziehungen',
	'visUsageTrend': 'Trend',
	'visUsagePartsToWhole': 'Teile zum Ganzen',
	'visUsageGeospatial': 'Geografisch-räumlich',
	'visUsageAdvanced': 'Erweiterte Analyse',
	'visUsageTablesAndSummary': 'Tabellen und Zusammenfassung',
	'visUsageSocialInsights': 'Social Insights',
	'visUsageOther': 'Sonstige',
	'autoBinActionText': 'Automatisch gruppieren',
	'filterAutobinActionText': 'Bins filtern',
	'memberCalculationActionText': 'Berechnung von Mitgliedern',
	'toolbarActionCalculation': 'Berechnung erstellen',
	'toolbarActionEditCalculation': 'Berechnung bearbeiten',
	'topBottomRankLabel': 'Rangfolge (%{label})',
	'toolbarDeleteFilterActionText': 'Filter entfernen',
	'toolbarActionTopKeyDrivers': 'Einflussfaktoren anzeigen',
	'toolbarActionCustomGroup': 'Benutzerdefinierte Gruppe',
	'canNotCreateCustomGroup': 'Diese benutzerdefinierte Gruppe kann nicht erstellt werden.',
	'aria_label_datatable': 'Datentabelle',
	'summaryCaption': 'Zusammenfassung',
	'MeasuresCaption': 'Kennzahlen',
	'MeasuresGroupCaption': 'Kennzahlengruppe (%{count})',
	'ValuesCaption': 'Werte',
	'turnInsightsOn': 'Insights aktivieren',
	'turnInsightsOff': 'Insights inaktivieren',
	'decisionRules': 'Regeln',
	'decisionTree': 'Verzeichnisstruktur - Diagramm',
	'decisionSunburst': 'Verzeichnisstruktur - Sunburst-Diagramm',
	'switchToDecisionRules': 'Zu Entscheidungsregeln wechseln',
	'switchToDecisionTree': 'Zur Entscheidungsstruktur wechseln',
	'data_group_less_then': 'kleiner als %{rangeTo}',
	'data_group_to': '%{rangeFrom} bis < %{rangeTo}',
	'data_group_and_above': 'ab %{rangeFrom}',
	'nullValueContent': '(kein Wert)',
	'sum': 'Summe',
	'count': 'Anzahl',
	'countdistinct': 'Anzahl eindeutiger Elemente',
	'avg': 'Durchschnitt',
	'min': 'Minimum',
	'max': 'Maximum',
	'automatic': 'Benutzerdefiniert',
	'variance': 'Varianz',
	'stddev': 'Standardabweichung',
	'median': 'Median',
	'calculated': 'Berechnet',
	'none': 'Ohne',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'promptTitle': 'Eingabeaufforderungswerte',
	'inputLabelPrompt': 'Wert',
	'inputPlaceholderPrompt': 'Wert eingeben',
	'inputInvalidText': 'Ungültige Eingabe für den Typ %{dataType}',
	'unSupportedPrompt': 'Nicht unterstützte Eingabeaufforderung',
	'missingDataSource': 'Die korrekte Datenquelle konnte nicht gefunden werden.',
	'unSupportedPromptType': 'Das Eingabeaufforderungsszenario wird zurzeit nicht unterstützt.',
	'preAggregateLabel': 'Eingabeaufforderungswerte aus der Datenquelle anwenden',
	'postAggregateLabel': 'Eingabeaufforderungswerte im Bericht anwenden',
	'preAggregateText': 'Der Bereich verwendet die Werte in der Datenquelle, nicht die im Dashboard angezeigten Werte.',
	'defaultAggregation_count': 'Anzahl',
	'defaultAggregation_countdistinct': 'Anzahl eindeutiger Elemente',
	'defaultAggregation_max': 'Maximum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Durchschnitt',
	'defaultAggregation_sum': 'Summe',
	'defaultAggregation_auto': 'Autom. (%{aggregationType})',
	'keydriver_average': 'Gesamtdurchschnitt',
	'keydriver_up_down': 'Hervorgehobene Gruppen mit hohen oder niedrigen Durchschnitten haben einen größeren Einfluss auf das Ziel. Gruppen mit ungewöhnlich hohen oder niedrigen Durchschnitten haben den größten Einfluss.',
	'keydriver_different': 'Hervorgehobene Gruppen weisen Verteilungen auf, die sich signifikant von der Gesamtverteilung unterscheiden. Diese Gruppen haben einen größeren Einfluss auf das Ziel.',
	'topOperator': 'Obere',
	'bottomOperator': 'Untere',
	'topBottomFact': '%{operator} %{value}%{percent} nach %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Anzahl oberer oder unterer Werte löschen',
	'deleteTopBottomPercent': 'Prozentsatz oberer oder unterer Werte löschen',
	'topBottomTitle': 'Nur dieses Objekt',
	'deleteTopBottom': 'Anzahl oberer oder unterer Werte löschen',
	'editTopBottom': 'Anzahl oberer oder unterer Werte bearbeiten',
	'editTopBottomCount': 'Anzahl oberer oder unterer Werte bearbeiten',
	'editTopBottomPercent': 'Prozentsatz oberer oder unterer Werte bearbeiten',
	'ariaDeleteTopBottomCountLabel': 'Zum Löschen der Anzahl oberer oder unterer Werte Löschtaste drücken.',
	'ariaDeleteTopBottomPercentLabel': 'Zum Löschen des Prozentsatzes oberer oder unterer Werte Löschtaste drücken.',
	'ariaEditTopBottomCountLabel': 'Zum Bearbeiten der Anzahl oberer oder unterer Werte Eingabetaste drücken.',
	'ariaEditTopBottomPercentLabel': 'Zum Bearbeiten des Prozentsatzes oberer oder unterer Werte Eingabetaste drücken.',
	'ariaDeleteDrillStateLabel': 'Zum Bearbeiten der Anzahl oberer oder unterer Werte Eingabetaste drücken.',
	'drillUpStateTitle': 'Drillup',
	'drillDownStateTitle': 'Drilldown',
	'ariaEditTopBottomLabel': 'Zum Bearbeiten der Anzahl oberer oder unterer Werte Eingabetaste drücken.',
	'ariaDeleteTopBottomLabel': 'Zum Löschen der Anzahl oberer oder unterer Werte Löschtaste drücken.',
	'allKeyDriversLabel': 'Automatisch (alle Einflussfaktoren)',
	'filter_drag_and_drop_single_dock': 'Daten zum Filtern hierher ziehen und ablegen.',
	'filter_drag_and_drop_all_tabs': 'Daten hierher ziehen und ablegen, um alle Registerkarten zu filtern.',
	'filter_drag_and_drop_current_tab': 'Daten hierher ziehen und ablegen, um diese Registerkarte zu filtern.',
	'filter_empty_consume_mode': 'Es wurden keine Filter angewendet.',
	'filterClearAllItems': 'Alle Filter aufheben',
	'filterDeleteAllItems': 'Alle Filter löschen',
	'filterDockChevronLeft': 'In den Daten blättern',
	'filterDockChevronRight': 'In den Daten blättern',
	'filterIconLabel_Single': 'Filter',
	'filterIconLabel_Global': 'Alle Registerkarten',
	'filterIconLabel_Tab': 'Diese Registerkarte',
	'filterIconTooltip_Single': 'Filter',
	'filterIconTooltip_Global': 'Filter für alle Registerkarten',
	'filterIconTooltip_Tab': 'Filter für diese Registerkarte',
	'filterDropZoneTooltip_Single': 'Filterablagebereich',
	'filterDropZoneTooltip_Global': 'Filterablagebereich für alle Registerkarten',
	'filterDropZoneTooltip_Tab': 'Filterablagebereich für diese Registerkarte',
	'filterOverflowMenu': 'Mehr',
	'expand': 'Einblenden',
	'collapse': 'Ausblenden',
	'filterDockItemNameAriaLabel': 'Zum Starten des Filterdialogs und zum Definieren des Filters die Eingabetaste drücken.',
	'filterItemCanvasMove': 'Zum Erstellungsbereich hinzufügen',
	'filterItemDelete': 'Filter löschen',
	'filterInvertRange': 'Alles außer: %{from} - %{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': 'Nicht nach %{from}',
	'filter_date_after': 'Nach %{from}',
	'filter_date_before_except': 'Nicht vor %{to}',
	'filter_date_before': 'Vor %{to}',
	'filter_date_between_except': 'Nicht zwischen %{from} und %{to}',
	'filter_date_between': 'Zwischen %{from} und %{to}',
	'filterValueSeparator': ',',
	'filterAll': 'Alle',
	'filter': 'Filtern',
	'filterExcept': 'Außer %{values}',
	'filterDockToolbarButtonLabel': 'Filter-Dock',
	'navigateTitle': 'Navigieren zu',
	'navigateSelectColumn': 'Spalte auswählen',
	'navigateSelectPath': 'Navigationspfad auswählen',
	'current_nav_group': 'Aktuelle Navigationsgruppe: %{navigation_group_name}',
	'next': 'Weiter',
	'previous': 'Zurück',
	'multiselectMsg': '%{count} ausgewählt',
	'errMsgFilterItemMissingTitle': 'Filterwert(e) %{itemName} kann bzw. können nicht geladen werden, da diese Werte nicht mit diesem Dataset verfügbar sind.',
	'errMsgFilterItemGenericTitle': 'Laden der Filterwerte nicht möglich',
	'textFilterItemsNotFound': 'Keine Elemente verfügbar.',
	'nullValueLabel': '(leer)',
	'filterConditionLabel': 'Filterbedingung',
	'filter_includesAll': 'Alles einbeziehen',
	'filter_allMembersOfSet': 'Alle Mitglieder des Satzes',
	'modelFilter': 'Filtern',
	'filtersTitle': 'Filtereigenschaften',
	'search': 'Suchen',
	'clearTextFilterValue': 'Aufheben',
	'invertFilterSelection': 'Auswahl umkehren',
	'modellingLoading': 'Ladeoperation wird ausgeführt...',
	'searchAll': 'Alle Spalten suchen',
	'toolbarActionPossibleKeyDrivers': 'Bereich bearbeiten',
	'toolbarActionPossibleKeyDriversSubTitle': 'Elemente aus dem linken Anzeigebereich ziehen, die im Diagramm für die Einflussfaktoranalyse berücksichtigt werden sollen.',
	'toolbarActionSort': 'Sortieren',
	'toolbarActionSortAscending': 'Aufsteigend',
	'toolbarActionSortDescending': 'Absteigend',
	'toolbarActionSortAuto': 'Autom. (%{sortOrder})',
	'toolbarActionSortCustom': 'Benutzerdefiniert',
	'toolbarActionFormat': 'Daten formatieren',
	'toolbarActionFormatText': 'Daten formatieren (Text)',
	'toolbarActionFormatAbbreviation': 'Abkürzen',
	'toolbarActionFormatNone': 'Automatisch',
	'toolbarActionFilter': 'Filtern',
	'toolbarActionTopBottom': 'Oben oder unten',
	'toolbarActionRmvShape': 'Form entfernen',
	'toolbarActionToggleShapeDrop': 'Form der Infografik',
	'toolbarActionToggleShapeDropTitle': 'Infografik erstellen',
	'toolbarActionToggleShapeDropText': 'Eine Form in dieses Feld ziehen, um eine Infografik zu erstellen.',
	'toolbarActionAggregationType': 'Auswerten',
	'toolbarDeleteActionText': 'Spalte entfernen',
	'toolbarTextActionText': 'Textstil',
	'toolbarActionFilterLocalKeepSelected': 'Beibehalten',
	'toolbarActionFilterLocalExcludeSelected': 'Ausschließen',
	'toolbarActionFilterAllKeepSelected': 'Filtern',
	'toolbarActionSimpleCalculation': 'Einfache Berechnung',
	'toolbarActionDrillBack': 'Zurück',
	'toolbarActionDrillUp': 'Drillup',
	'toolbarActionDrillDown': 'Drilldown',
	'toolbarActionJumpTo': 'Drillthrough durchführen',
	'toolbarActionNavigate': 'Navigation',
	'toolbarActionCreateFilterGroup': 'Neue Verbindung erstellen',
	'toolbarActionDisconnectFilterGroup': 'Alle Links trennen',
	'toolbarActionLinkFilterGroup': 'Zu einer vorhandenen Verbindung hinzufügen',
	'toolbarActionLassoSelect': 'Tool auswählen',
	'toolbarActionRefreshDeveloperWidget': 'Aktualisieren',
	'textFontFamilySubClassHairline': 'Haarlinie',
	'textFontFamilySubClassThin': 'Dünn',
	'textFontFamilySubClassThinItalic': 'Dünn kursiv',
	'textFontFamilySubClassExtraLight': 'Sehr hell',
	'textFontFamilySubClassExtraLightItalic': 'Sehr hell kursiv',
	'textFontFamilySubClassLight': 'Hell',
	'textFontFamilySubClassLightItalic': 'Hell kursiv',
	'textFontFamilySubClassRegular': 'Normal',
	'textFontFamilySubClassRegularItalic': 'Normal kursiv',
	'textFontFamilySubClassItalic': 'Kursiv',
	'textFontFamilySubClassMedium': 'Mittel',
	'textFontFamilySubClassMediumItalic': 'Mittel kursiv',
	'textFontFamilySubClassHeavy': 'Stark',
	'textFontFamilySubClassHeavyItalic': 'Stark kursiv',
	'textFontFamilySubClassDemiBold': 'Halbfettdruck',
	'textFontFamilySubClassDemiBoldItalic': 'Halbfettdruck kursiv',
	'textFontFamilySubClassBold': 'Fettdruck',
	'textFontFamilySubClassBoldItalic': 'Fettdruck kursiv',
	'textFontFamilySubClassExtraBold': 'Extrafettdruck',
	'textFontFamilySubClassExtraBoldItalic': 'Extrafettdruck kursiv',
	'textFontFamilySubClassBlack': 'Schwarz',
	'textFontFamilySubClassBlackItalic': 'Schwarz kursiv',
	'textFontFamilySubClassStencil': 'Schablone',
	'dlg_ascending': 'aufsteigend',
	'dlg_descending': 'Absteigend',
	'dlg_custom': 'benutzerdefiniert',
	'dlg_none': 'Ohne',
	'dlg_hierarchy': 'Hierarchie',
	'dlg_namedSet': 'Benannter Satz',
	'dlg_rank': 'Rangfolge',
	'visualizationLabel': 'Visualisierung',
	'chartLabel': 'Diagramm %{chartName}',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Mit F12 im Widget navigieren.',
	'f10KeyDescription': 'Mit F10 die im Fokus befindliche Ansicht des Widgets starten',
	'playButtonLabel': 'Wiedergabe',
	'dataPlayerValueListLabel': 'Data Player-Werte',
	'localFilterTitle': 'Nur dieses Objekt',
	'globalFilterTitle': 'Alle Objekte',
	'deleteFilter': 'Filter löschen',
	'editFilter': 'Filter bearbeiten',
	'ariaEditFilterLabel': 'Zum Bearbeiten des Filters die Eingabetaste drücken.',
	'ariaDeleteFilterLabel': 'Zum Löschen des Filters die Löschtaste drücken.',
	'measureFilterBetween': 'Zwischen %{lowerBound} und %{upperBound}',
	'measureFilterNotBetween': 'Nicht zwischen %{lowerBound} und %{upperBound}',
	'dimFilterIn': 'Einbezogen: %{in}',
	'dimFilterNotIn': 'Ausgeschlossen: %{out}',
	'gtFilter': 'Nach %{lowerBound}',
	'ltFilter': 'Vor %{upperBound}',
	'ariaEditPrompt': 'Zum Ändern des Eingabeaufforderungswerts die Eingabetaste drücken',
	'dataPointFilterTitle': 'Datenpunkte',
	'dataPointFilterIncludeSummary': '%{valueCount} Datenpunkte einbezogen',
	'dataPointFilterExcludeSummary': '%{valueCount} Datenpunkte ausgeschlossenb',
	'widgetFiltersLabel': 'Widgetfilter',
	'coachMarkTitleSpiralTarget': 'Bereich bearbeiten',
	'coachMarkContentSpiralTarget': 'Hier können Sie auf die Auswahl der Einflussfaktoren für das Ziel zugreifen und gegebenenfalls Änderungen vornehmen.',
	'srILVTreeLabel': 'Liste',
	'geomapUnrecognizedLocations': 'Nicht erkannte Positionen:',
	'geomapAmbiguousLocations': 'Nicht eindeutige Regionen:',
	'visualizationNotifications': 'Visualisierungsbenachrichtigungen:',
	'dataNotifications': 'Datenbenachrichtigungen:',
	'autobinSuggestion': 'Automatisches Gruppieren aktivieren',
	'LIVE_empty_visualization_hint_title': 'Visualisierung erstellen',
	'LIVE_empty_visualization_hint_description': 'Daten hierher oder in die Felder ziehen.',
	'LIVE_slots_required_field_description': '%{asterisk} Kennzeichnet ein erforderliches Feld',
	'LIVE_slots_drag_and_drop_description': 'Daten in die Felder oben ziehen und ablegen, um die Visualisierung zu erstellen und zu filtern.',
	'dwErrorLoadingAvailableVisualizations': 'Die verfügbaren Visualisierungsdefinitionen können nicht geladen werden.',
	'moreDataIndicator': 'Die Daten wurden nach %{threshold} Elementen abgeschnitten. Wenden Sie einen Filter an, um weniger Elemente anzuzeigen.',
	'nonCtxTopBottomInvalid': 'Die Definition einer Regel für obere oder untere Werte ohne Kontext wird für Kreuztabellen nicht unterstützt. Sie wurde aus dieser Kreuztabellenansicht entfernt.  Definieren Sie die Regel für eine oder mehrere Kategorien im Kontext von %{columnName} erneut.',
	'dwErrorLoadingVisualizationNotFound': 'Das Objekt kann nicht geladen werden, da eine Visualisierungsdefinition fehlt.',
	'dwErrorLoadingVisualizationListNotFound': 'Die Visualisierung kann nicht geladen werden.',
	'dwErrorRunningQuery': 'Die Daten aus dem Dataset %{datasetName} können nicht abgerufen werden.',
	'dwErrorGeoData': 'Es gibt Probleme bei der Anzeige der geografischen Daten in einer Karte. Wählen Sie einen anderen Visualisierungstyp aus.',
	'dwPromptSignonCancelWarning': 'Die Daten für diese Visualisierung sind nicht verfügbar. Geben Sie die korrekten Berechtigungsnachweise an.',
	'dwErrorMissingDataset': 'Die Visualisierung kann nicht geladen werden, da das zugehörige Dataset "%{datasetName}" nicht verfügbar ist.',
	'dwErrorRenderingVisualization': 'Diese Visualisierung kann nicht geladen werden.',
	'dwErrorVisualizationTooSmall': 'Die Visualisierung ist für die Anzeige der darin enthaltenen Daten zu klein. Vergrößern Sie die Visualisierung oder verringern Sie die Menge der darin enthaltenen Daten.',
	'errorSourceNotFound': 'Die Visualisierung kann nicht geladen werden, da die zugehörige Quelle "%{sourceName}" nicht verfügbar ist.',
	'errorActionNotSupported': 'Diese Aktion wird für die Datenquelle "%{sourceName}" nicht unterstützt.',
	'errorMeasureNotSupportedOnMultiEdges': 'Die Visualisierung weist Kennzahlen auf mehreren Edge-Systemen auf; dies wird nicht mehr unterstützt. Kennzahlen dürfen nur auf einem einzelnen Edge-System vorhanden sein.',
	'errorExceedAllowableValue': 'Die geschätzte Zellenanzahl überschreitet den zulässigen Wert von 100000. Wenden Sie Filter für projizierte Sätze an, um die Zellenanzahl zu reduzieren.',
	'propScaleLabel': 'Menge der Symbole',
	'propScaleDescription': 'Menge der Symbole auswählen',
	'propScaleFew': 'Niedrig',
	'propScaleDefault': 'Standard',
	'propScaleMany': 'Hoch',
	'lastRefresh': 'Letzte Aktualisierung: Vor %{timeInterval}',
	'widgetTimer': 'Widget-Zeitgeber',
	'datasetItemsUnavailable': 'Einige Datasetelemente in dieser Visualisierung sind nicht verfügbar.',
	'datasetItemUnavailable': 'Dieses Dataset ist nicht verfügbar',
	'retry': 'Wiederholen',
	'widgetConditionalFormatLabel': 'Steuerelemente zum Wechseln bedingter Formate',
	'widgetConditionalFormatTitle': 'Farbe für bedingte Formatierung bearbeiten',
	'crosstabName': 'Kreuztabelle',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'Nicht zutreffend',
	'summaryLabel': '%{label} mit Wert %{value}',
	'infographicLabel': '%{label} mit Wert %{value}',
	'warning': 'Warnung',
	'swapRowsAndColumns': 'Zeilen und Spalten tauschen',
	'hideSummariesLabel': 'Zusammenfassungen ausblenden',
	'showSummariesLabel': 'Zusammenfassungen anzeigen',
	'hideRowColumn': 'Ausblenden',
	'showAllRowColumn': 'Alle anzeigen',
	'dataAssetPropertiesLabel': 'Visualisierungseigenschaften',
	'evAdd': 'Spalte hinzufügen',
	'evCollapse': 'Ausblenden',
	'evColumns': 'Spalten',
	'evLocalFilters': 'Lokale Filter',
	'evExpand': 'Einblenden',
	'evFilterTooltip': 'Filtern',
	'missingColumn': 'Nicht vorhanden: %{columnLabel}',
	'missingFiltering': 'Filter für die folgenden Spalten vorhanden:',
	'missingDataItem': 'Das referenzierte Datenelement "%{dataItemId}" wurde im Widget nicht gefunden.',
	'heatByLabel': 'Heat-Map nach',
	'toolbarChangeVisualization': 'Visualisierung ändern',
	'modellingRelatedTablesNoneFound': 'Keine zugehörigen Tabellen gefunden',
	'processing': 'Verarbeitung wird ausgeführt...',
	'errorCellWarning': 'Einige Zusammenfassungswerte konnten nicht berechnet werden.',
	'aggregateTypeToggler': 'Aggregationstyp anzeigen',
	'maxColumnsExceeded': 'Maximale Anzahl von Spalten überschritten. %{columns} gelöscht.',
	'unboundColumns': 'Verwenden der folgenden Spalten nicht möglich: %{columns}.',
	'unboundColumn': 'Verwenden der folgenden Spalte nicht möglich: %{columns}.',
	'recommendRequestFailed': 'Empfehlungsanforderung fehlgeschlagen. Wenden Sie sich an den zuständigen Administrator.',
	'visualizationDoesNotSupportOLAP': 'Die Erstellung dieser Visualisierung, die auf einer OLAP-Datenquelle basiert, ist nicht möglich. Eine andere unterstützte Datenquelle verwenden.',
	'showDataBehindVizLabel': 'Daten anzeigen',
	'showDataBehindVizNotSupportedLabel': 'Das Anzeigen von Daten wird für diesen Visualisierungstyp nicht unterstützt.',
	'exploreData': 'Erkunden...',
	'newExplore': 'Neue Exploration',
	'thumbnails_error_fetching': 'Fehler beim Abrufen von Piktogrammen',
	'loadedThumbnailImage': 'Piktogramm für Visualisierung des Typs %{visType} geladen.',
	'autobinAxisLabel': 'Gruppen',
	'recommended_visualizations': 'Empfohlene Visualisierungen',
	'all_visualizations': 'Alle Visualisierungen',
	'edit': 'Bearbeiten',
	'selectTargetDialogTitle': 'Drillthrough-Ziel ausblenden',
	'noTargetInCM': 'Drillthrough-Ziel kann nicht gefunden werden.',
	'errorDrillDefinition': 'Beim Hinzufügen oder Bearbeiten der Drillthrough-Definition ist ein Fehler aufgetreten.',
	'errorDrillToTarget': 'Beim Drillthrough zu "%{targetName}" ist ein Fehler aufgetreten.',
	'drillThroughMappingViewLabel': 'Spalten aus dem Dashboard den Eingabeaufforderungen des Zielberichts zuweisen.',
	'drillthroughScopeRadioLabel': 'Diese Definition anwenden für:',
	'drillthroughScopeRadioOptionVisualization': 'Nur diese Visualisierung',
	'drillthroughScopeRadioOptionConnection': 'Visualisierungen in derselben Verbindung, die dieselbe Datenquelle verwenden',
	'drillthroughScopeRadioOptionDashboard': 'Beliebige Visualisierungen in %{perspective}, die dieselbe Datenquelle verwenden',
	'drillThroughParametersColumnTitle': 'Eingabeaufforderungen für "%{targetName}":',
	'drillThroughMetadataColumnTitle': 'Datenspalten für "%{boardName}":',
	'drillThroughDefinitionNoParameter': 'Das Drillthrough-Ziel weist keine Eingabeaufforderungen auf.',
	'drillThroughDefinitionErrorQueryingReport': 'Beheben sie das Problem mit dem Zielbericht und versuchen Sie, die Drillthrough-Definition erneut zu erstellen.',
	'drillThroughDefinitionErrorDlgTitle': 'Ein Fehler ist aufgetreten',
	'dlg_back': 'Zurück',
	'dlg_close': 'Schließen',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Abbrechen',
	'dlg_apply': 'Anwenden',
	'dlg_create': 'Erstellen',
	'dlg_done': 'Fertig',
	'drillthrough_unsaveMsg': 'Aktion fortsetzen, ohne  "%{name}" zu speichern?',
	'drillthrough_jumpTo': 'Drillthrough-Definition: %{name}',
	'drillthrough_jumpToLabel': 'Drillthrough durchführen',
	'drillthrough_manage': 'Verwalten...',
	'drillthrough_addNewTarget': 'Neue Drillthrough-Definition hinzufügen',
	'drillthrough_manageJumpPaths': 'Drillthrough-Definitionen verwalten',
	'drillthrough_manageJumpPaths_edit': '"%{name}" bearbeiten',
	'drillthrough_manageJumpPaths_delete': '"%{name}" löschen',
	'drillthrough_manageAddAnotherTarget': 'Weitere Drillthrough-Definition hinzufügen',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Löschen bestätigen',
	'drillthrough_manageConfirmeDeleteDrillTarget': 'Soll der Drillthrough "%{name}" tatsächlich gelöscht werden?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Doppelter Drillthrough-Name',
	'drillthrough_definitionMessage': 'Drillthrough "%{name}" ist bereits vorhanden. Einen anderen Namen angeben.',
	'drillthrough_jumpToTarget_notFound': 'Ziel für Drillthrough "%{name}" nicht gefunden.',
	'drillThroughDefinitionNoParameterSubTitle': 'Es wird kein Kontext an den Zielbericht übergeben.',
	'drillthrough_titleLabel': 'Name',
	'drillthrough_create_dialogTitle': 'Drillthrough-Definition erstellen',
	'drillthrough_edit_dialogTitle': 'Drillthrough-Definition bearbeiten',
	'drillthrough_subTitle': 'Der Kontext der Visualisierung in der Quelle wird zum Filtern des Ziels %{perspective} verwendet.',
	'drillthrough_selectColumn': 'Spalte auswählen',
	'noPrompt': 'Keine Eingabeaufforderungen',
	'promptDialog': '%{promptType} - Eingabeaufforderungsdialog',
	'formatAutoDescription': 'Automatisch - von der Datenquelle oder Visualisierung übernommenes Format',
	'formatDefaultDescription': 'Standard - vom System übernommenes Format',
	'createCustomGroupAction': 'Datengruppe erstellen',
	'removeCustomGroupAction': 'Datengruppe entfernen',
	'editCustomGroupAction': 'Datengruppe bearbeiten',
	'renameCustomGroupAction': 'Datengruppe umbenennen',
	'createCustomGroupErrorToast': 'Die Datengruppe konnte nicht erstellt werden.',
	'removeCustomGroupErrorToast': 'Die Datengruppe konnte nicht entfernt werden.',
	'editCustomGroupErrorToast': 'Die Datengruppe konnte nicht bearbeitet werden.',
	'renameCustomGroupErrorToast': 'Die Datengruppe konnte nicht umbenannt werden.',
	'customGroupLabel': 'Datengruppe erstellen',
	'ungroupCustomGroupLabel': 'Gruppierung aufheben',
	'renameCustomGroupLabel': 'Umbenennen',
	'createCustomGroupLabel': 'Erstellen',
	'customGroupingLabel': '%{columnLabel} (Gruppe)',
	'createCustomSort': 'Benutzerdefinierte Sortierung erstellen',
	'createCustomSortTitle': '%{name}',
	'createCustomSortDesc': 'Verfügbare Elemente auswählen und anschließend neu anordnen, um eine benutzerdefinierte Sortierung zu erstellen.',
	'availableItems': 'Verfügbare Elemente',
	'selectAll': 'Alles auswählen',
	'customSortOrder': 'Benutzerdefinierte Sortierreihenfolge',
	'selectAvailableItemsDesc': 'Verfügbare Elemente auswählen und anschließend hier neu anordnen.',
	'moveToTop': 'Zum Anfang',
	'clear': 'Aufheben',
	'sortRemainingItemsBy': 'Verbleibende Elemente sortieren nach',
	'removeAll': 'Alles entfernen',
	'resetTooltip': 'Alle Elemente werden aus der Liste %{customSortOrder} entfernt. Darüber hinaus wird die Dropdown-Liste %{sortRemainingItemsBy} auf die Standardeinstellung zurückgesetzt.',
	'manyItemsWarning': 'Die Auswahl einer große Anzahl von Elementen kann sich auf die Leistung des Dashboards auswirken.',
	'manyItemsSelected': 'Es wurden mehr als %{maxItems} Elemente ausgewählt, dies kann sich auf die Leistung des Dashboards auswirken.',
	'somethingWentWrong': 'Es ist ein Fehler aufgetreten. ',
	'tryAgain': 'Wiederholen',
	'customSortLabel': 'Benutzerdefinierte Sortierung',
	'applyError': 'Anwenden der Aktion %{action} nicht möglich.',
	'searchReturnedNoResults': 'Die Suche hat keine Ergebnisse geliefert. ',
	'extVisSystem': 'System',
	'extVisCustom': 'Benutzerdefiniert',
	'customVisTestVisualization': 'Visualisierung testen',
	'extVisCustomVisPreview': 'Vorschau',
	'extVisCustomPreviewWidgets': 'Entwicklerwidgets',
	'extVisCustomVVisualization': 'Visualisierung',
	'extVisCustomVisuals': 'Benutzerdefinierte visuelle Elemente',
	'noPermissionToManage': 'Sie verfügen nicht über die Berechtigung zur Verwaltung benutzerdefinierter Visualisierungen.',
	'extVisCustomUpdate': 'Aktualisieren',
	'extVisCustomDelete': 'Löschen',
	'extVisNoCustomVisuals': 'Keine benutzerdefinierten visuellen Elemente',
	'extVisNoCustomVisualsMsg': 'Derzeit befinden sich keine visuellen Elemente in Ihrer Organisation',
	'extVisAddCustomVisual': 'Benutzerdefiniertes visuelles Element hinzufügen',
	'extVisNoCustomVisualsAdminMsg': 'Derzeit sind keine benutzerdefinierten visuellen Elemente vorhanden. Als ersten Schritt ein Element hinzufügen.',
	'extVisNoSDKConnection': 'Es wurde keine Verbindung zur lokalen Datei erstellt.',
	'extVisNoSDKPreviewMsg': 'Für eine Vorschau der Visualisierungen eine Verbindung einrichten.',
	'extVisMore': 'Mehr',
	'extVisDeleteDialogTitle': 'Benutzerdefiniertes visuelles Element löschen',
	'extVisDeleteDialogBody': 'Soll dieses benutzerdefinierte visuelle Element tatsächlich gelöscht werden? Es wird möglicherweise von anderen Dashboards und Berichten verwendet.',
	'extVisDeleteConfirmation': 'Das benutzerdefiniert visuelle Element wurde gelöscht.',
	'extVisDeleteError': 'Das benutzerdefiniert visuelle Element konnte nicht gelöscht werden. %{msg}',
	'extVisCloseToast': 'Jetzt schließen',
	'extVisAdd': 'Das benutzerdefiniert visuelle Element wurde erfolgreich hinzugefügt.',
	'extVisAddError': 'Das benutzerdefiniert visuelle Element konnte nicht hinzugefügt werden. %{msg}',
	'extVisUpdate': 'Das benutzerdefiniert visuelle Element wurde erfolgreich aktualisiert.',
	'extVisUpdateError': 'Das benutzerdefiniert visuelle Element konnte nicht aktualisiert werden. %{msg}',
	'extVisAddProgress': '%{name} wird importiert.',
	'extVisUpdateProgress': '%{name} wird aktualisiert.',
	'extPermissionTitle': 'Zugriff eingeschränkt oder benutzerdefiniertes visuelles Element gelöscht',
	'extPermissionBody': 'Das benutzerdefinierte visuelle Element kann nicht angezeigt werden, da es entweder gelöscht wurde oder da der Zugriff darauf eingeschränkt ist.',
	'customVizSaveWarning': 'Die benutzerdefinierten visuellen Elemente können nicht gespeichert werden. Sie wurden nicht importiert.',
	'schematicTestCaption': 'Schema testen',
	'schematicServiceRequestError': 'Schemaservicefehler',
	'extVisPreviewMessage': 'Dies ist eine Vorschau. Die Visualisierung wurde noch nicht zum Produkt hinzugefügt.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Nicht definiert',
	'kpiDefaultTargetLabel': 'Ziel',
	'kpiNonNumericTarget': 'Der Zielwert muss eine Zahl sein.',
	'kpiManualTargetSlotFilled': 'Wert für Feld angewendet',
	'kpiAutoValueSize': 'Automatisch',
	'kpiUnableDrawSparklineLabel': 'Darstellung einer Sparkline nicht möglich',
	'kpiUnableDrawSparklineInfo': 'Für eine Sparkline sind mindestens zwei Zeitpunkte erforderlich. Die Daten ändern oder die Filter anpassen, um eine Sparkline anzuzeigen.',
	'conditionalFormattingTextColor': 'Textfarbe',
	'suppression': 'Unterdrückung',
	'suppressNone': 'Ohne',
	'suppressRowsAndColumns': 'Zeilen und Spalten',
	'suppressRows': 'Zeilen',
	'suppressColumns': 'Spalten',
	'enableSuppression': 'Unterdrückung aktivieren',
	'disableSuppression': 'Unterdrückung inaktivieren',
	'loadVisDefinitionError': 'Laden der Definition für die Visualisierung nicht möglich: %{id}',
	'emptyVisualization': 'Leere Visualisierung',
	'expandCollapse': 'Einblenden & ausblenden',
	'expandBtnLabel': 'Einblenden',
	'collapseBtnLabel': 'Ausblenden',
	'prop_sizeInputNonNumericValue': 'Der Wert muss eine Zahl sein.',
	'prop_sizeValueShouldBeHigher': 'Der Wert muss größer als %{value} sein.',
	'fontPropLabel': 'Schriftartengruppe',
	'fontSizePropLabel': 'Schriftgröße',
	'sectionItemAxisTitle': 'Elementachsentitel',
	'sectionItemAxisLabel': 'Elementachsenbeschriftung',
	'sectionValueAxisTitle': 'Wertachsentitel',
	'sectionValueAxisLabel': 'Wertachsenbeschriftung',
	'styletext-widget.legend': 'Legende',
	'styletext-itemAxis.ticks.labels': 'Achsenbeschriftungen',
	'styletext-valueAxis.title': 'Achsentitel',
	'styletext-itemAxis.title': 'Achsentitel',
	'styletext-labels': 'Datenbeschriftungen',
	'styletext-valueAxis.line.title': 'Linientitel',
	'styletext-cellValue': 'Werte',
	'styletext-values': 'Werte',
	'styletext-rowHeading': 'Zeilenüberschriften',
	'styletext-columnHeading': 'Spaltenüberschriften',
	'fontFamily': 'Schriftartengruppe',
	'fontSize': 'Schriftgröße',
	'visExportFileName': 'Visualisierung',
	'ds-missingDataSet': 'Das Dataset konnte nicht gefunden werden. Stellen Sie sicher, dass das Dataset erfolgreich erstellt wurde.',
	'ds-missingDashboardId': 'Dashboard vor dem Erstellen des Datasets speichern.',
	'ds-unsupportedDataSourceType': 'Der Datenquellentyp %{type} wird nicht unterstützt.',
	'dataCache': 'Datencache',
	'dataCache_on': 'Aktiviert',
	'dataCache_off': 'Kein Cache',
	'dataCache_auto': 'Automatisch',
	'queryOptimization': 'Abfrageoptimierung'
});
